import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, onMounted, onBeforeUnmount } from 'vue'
    import useIframeControl from '@/hooks/iframeInternalChat'
    import BoxInternChat from './BoxInternChat.vue'
    import StandbyBox from './StandbyBox.vue'
    import ErrorBox from './ErrorBox.vue'
    import useWebSocketChat from '@/hooks/useWebSocketChat'

    type Component = 'StandbyBox' | 'BoxInternChat' | 'ErrorBox'

    type State = {
        component: Component
        hasError: Error | null
        loading: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MountedBox',
  setup(__props) {

    const components = {
        BoxInternChat,
        StandbyBox,
        ErrorBox
    }

    const { open, close } = useWebSocketChat()
    const iframe = useIframeControl()

    const state = reactive<State>({
        component: 'ErrorBox',
        loading: false,
        hasError: null
    })

    function handleCloseBox(): void {
        iframe.notifyClose()
        state.component = 'StandbyBox'
    }

    function handleOpenBox(): void {
        iframe.notifyOpen()
        state.component = 'BoxInternChat'
    }

    function handleExternalBox() {
        iframe.notifyKill()
        state.loading = true
        const url = window.location.origin + '/v2/chat-interno'
        window.open(url, '_blank', 'popup=1,toolbar=0,location=0,menubar=0,width=900,height=800')
    }


    onMounted(async () => {
        state.loading = true
        open()
        state.component = 'StandbyBox'
        state.loading = false
    })

    onBeforeUnmount(() => {
        close()
    })


return (_ctx: any,_cache: any) => {
  return (!state.loading)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[state.component]), {
        key: state.component,
        onExternalBox: handleExternalBox,
        onOpenBox: handleOpenBox,
        onCloseBox: handleCloseBox
      }, null, 32))
    : _createCommentVNode("", true)
}
}

})